export default [
  {
    id: 1,
    content: '뒷 커버 등의 볼트 조임과 이완 및 바닥의 이물질 상태',
    isChecked: ''
  },
  {
    id: 2,
    content: '문의 개폐상태',
    isChecked: ''
  },
  {
    id: 3,
    content: '점검창과 패킹 등 열화에 의한 손상상태',
    isChecked: ''
  },
  {
    id: 4,
    content: '볼트류 등의 조임이 여부와 진동 및 소리상태',
    isChecked: ''
  },
  {
    id: 5,
    content: '점검창 등 오손 유무와 내부의 시야상태',
    isChecked: ''
  },
  {
    id: 6,
    content: '조임과 이완 등에 의한 탈거현상과 파손 및 선명도 상태',
    isChecked: ''
  },
  {
    id: 7,
    content: '인출기기의 접촉위치 및 단로위치의 상태',
    isChecked: ''
  },
  {
    id: 8,
    content: '적당한 위치의 정위치 유무',
    isChecked: ''
  },
  {
    id: 9,
    content: '전기 주회로 인입 인출부',
    isChecked: ''
  },
  {
    id: 10,
    content: '볼트류의 조임 유무와 이완 시 진동음의 상태',
    isChecked: ''
  },
  {
    id: 11,
    content: '균열, 파손도 상태',
    isChecked: ''
  },
  {
    id: 12,
    content: '방전 시에 의한 소리의 상태',
    isChecked: ''
  },
  {
    id: 13,
    content: '볼트류의 조임',
    isChecked: ''
  },
  {
    id: 14,
    content: '방전 시 또는 과열에 의한 냄새상태',
    isChecked: ''
  },
  {
    id: 15,
    content: '케이블 막이판의 탈락 또는 간격의 벌어짐 상태',
    isChecked: ''
  },
  {
    id: 16,
    content: '포유류, 조류, 파충류 등 기타 침입의 흔적상태',
    isChecked: ''
  },
  {
    id: 17,
    content: '부대시설 변형 및 콘크리트 탈락 유무',
    isChecked: ''
  },
];
